/* eslint jsx-a11y/label-has-for: 0 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Form, Text } from 'react-form';
import Button from 'components/button';
import { Link } from 'react-router-dom';

import './style.css';

class Login extends PureComponent {
  onSubmit(submittedValues) {
    const { authenticateUser } = this.props;
    authenticateUser(submittedValues);
  }

  render() {
    return (
      <div className="c-login">
        <Form onSubmit={submittedValues => this.onSubmit(submittedValues)}>
          {formApi => (
            <form onSubmit={formApi.submitForm}>
              <div className="form-row">
                <label htmlFor="email">Email:</label>
                <Text type="email" field="email" id="email" required />
              </div>
              <div className="form-row">
                <label htmlFor="password">Password:</label>
                <Text type="password" id="password" field="password" required />
              </div>
              <div className="form-row login-request -actions">
                <Button type="submit -login">Log In</Button>
                <Link className="c-button -long-text -login" to="/contact-us">Request Access</Link>
              </div>
            </form>
          )}
        </Form>
      </div>
    );
  }
}

Login.propTypes = {
  authenticateUser: PropTypes.func
};

Login.defaultProps = {
  authenticateUser: () => {}
};

export default Login;



// WEBPACK FOOTER //
// ./src/components/login-form/component.js